import { getRuntimeBlockId } from '../utils/runTimeBlocks';

// used to get the corresponding id that will be used to refer the block in global state store
export function useGetBlockStateId({
  originalBlockId,
  runtimeBlockKey,
}: {
  originalBlockId?: string;
  runtimeBlockKey?: string;
}) {
  // useMemo's dep-array bookkeeping costs more than the concat itself on this hot path.
  return {
    blockStateId:
      runtimeBlockKey && originalBlockId
        ? getRuntimeBlockId({ originalBlockId, runtimeBlockKey })
        : (originalBlockId ?? ''),
  };
}
